import { type Loader, LOADING } from '@/generic/loader/Loader.ts';
import type { ReactNode } from 'react';

export const LoaderComponent = <Content, Err extends Error>({
  loader,
  onSuccess,
  onLoading,
  onError,
}: {
  loader: Loader<Content, Err>;
  onSuccess: (content: Content) => ReactNode;
  onLoading: () => ReactNode;
  onError: (error: Err) => ReactNode;
}): ReactNode => {
  if (loader === LOADING) {
    return onLoading();
  }

  if (loader instanceof Error) {
    return onError(loader);
  }

  return onSuccess(loader);
};
